import { PageLoading } from 'module/ui/components/atoms/loading';
import { FC } from 'react';
import { MeetingPages } from 'components/organisms/meeting-pages';
import { AccountLayout } from './common/layout';
import { AccountsTabs, AccountsTabsType } from './common/tab';
import { useCompanyFromUrl } from './use-current-company';

export const AccountMeetingsPage: FC = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  return isCompanyLoading || company == null ? (
    <PageLoading />
  ) : (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.MeetingsPages} />}
      content={<MeetingPages company={company} />}
      actions={{}}
    />
  );
};
